<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'ランキング' | translate}}</h1>

  <!-- <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="rankingUpdate()">
      <mat-icon>refresh</mat-icon>
      <span>{{'exhibit-rankings.UPDATE' | translate}}</span>
    </button>
  </div> -->
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> {{'No.' | translate}} </th>
      <td mat-cell *matCellDef="let exhibit; let i = index"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="count">
      <th mat-header-cell *matHeaderCellDef> {{'いいね' | translate}} </th>
      <td mat-cell *matCellDef="let exhibit"> {{ exhibit.count }} </td>
    </ng-container>

    <ng-container matColumnDef="exhibit_id">
      <th mat-header-cell *matHeaderCellDef> {{'ID' | translate}} </th>
      <td mat-cell *matCellDef="let exhibit"> {{exhibit.exhibit_id}} </td>
    </ng-container>

    <ng-container matColumnDef="attribute">
      <th mat-header-cell *matHeaderCellDef> {{'属性' | translate}} </th>
      <td mat-cell *matCellDef="let exhibit">
        <span
          *ngFor="let attribute of (exhibit.exhibit_attribute_id | docsByCond:'exhibit_attributes':'attribute_id' | async)">
          {{ attribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> {{'名称' | translate}} </th>
      <td mat-cell *matCellDef="let exhibit"> {{ exhibit.exhibit_names | multiName:projectLanguages:projectBaseLang }} </td>
    </ng-container>

    <ng-container matColumnDef="file">
      <th mat-header-cell *matHeaderCellDef> {{'画像' | translate}} </th>
      <td mat-cell *matCellDef="let exhibit">
        <img *ngIf="!!exhibit.exhibit_files[0]"
          [src]="(exhibit.exhibit_files[0].file_id | doc:uploadedFilesCollectionName | async)?.download_url"
          height="40px" width="auto">
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> {{'更新日時' | translate}} </th>
      <td mat-cell *matCellDef="let exhibit"> {{ exhibit.updated.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>